import Card from "react-bootstrap/Card";
import OutboundLink from "./OutboundLink";
import styles from "../styles/PleaseSupportUs.module.scss";
import useCanRunAds from "../hooks/useCanRunAds";
import { useState } from "react";

const PleaseSupportUs = ({ always, height, width }) => {
  const canRunAds = useCanRunAds();
  const [randomRoll, setRandomRoll] = useState(Math.random());

  if (canRunAds && !always) {
    return null;
  }

  return (
    <Card className="shadow-sm">
      <div
        className={styles.container}
        style={{
          height: height || 200,
          width: width || "auto",
        }}
      >
        <OutboundLink url="https://patreon.com/edhrec" utm_medium="please_support_us">
          Please consider supporting us on Patreon to remove ads for only $2/month.
        </OutboundLink>
      </div>
    </Card>
  );
};

export default PleaseSupportUs;
